/**
 * @generated SignedSource<<7bcbc549c791e1ce71aa64234050cfbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type Storecast_Store$data = {
  readonly myRole: Roles;
  readonly " $fragmentType": "Storecast_Store";
};
export type Storecast_Store$key = {
  readonly " $data"?: Storecast_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"Storecast_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Storecast_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "37436f29d8f19595f7962fed15f5fd10";

export default node;
